import React from 'react';
import {
  List,
  Datagrid,
  TextField,
  CreateButton,
  TopToolbar,
  DateField,
  BooleanField,
} from 'react-admin';
import { Box, Breadcrumbs, Link, Typography } from '@mui/material';
import NavigateNextIcon from '@mui/icons-material/NavigateNext';
import { useNavigate } from 'react-router-dom';
import { CustomEmptyState } from '../../components/CustomEmptyState';

const ServiceBlueprintListActions = () => (
  <TopToolbar>
    <CreateButton />
  </TopToolbar>
);

const ConfigurationBreadcrumbs = () => {
  const navigate = useNavigate();

  return (
    <Box sx={{ p: 2, backgroundColor: '#f8f9fa', borderRadius: 1, mb: 2 }}>
      <Breadcrumbs separator={<NavigateNextIcon fontSize="small" />}>
        <Link
          underline="hover"
          color="inherit"
          onClick={() => navigate('/configuration')}
          sx={{ cursor: 'pointer', '&:hover': { color: '#1976d2' } }}
        >
          Configuration
        </Link>
        <Typography color="text.primary">Service Blueprints</Typography>
      </Breadcrumbs>
    </Box>
  );
};

export const ServiceBlueprintList = () => {
  const navigate = useNavigate();

  return (
    <List
      title="Service Blueprints"
      actions={<ServiceBlueprintListActions />}
      filters={[]}
      empty={
        <CustomEmptyState
          resource="service-blueprints"
          onAction={() => navigate('/crm/service-blueprints/create')}
        />
      }
    >
      <ConfigurationBreadcrumbs />
      <Datagrid rowClick="edit" bulkActionButtons={false}>
        <TextField source="name" />
        <TextField source="description" />
        <BooleanField source="active" />
        <DateField source="createdAt" />
      </Datagrid>
    </List>
  );
};
